// import axios from 'axios';

function getUrl() {
  if (import.meta.env.VITE_NODE_ENV === 'development') {
    return `https://cdn.qinsilk.com/dms/prod/ebbb473fd34425e013a80d137c7a268c.json?t=${new Date().getTime()}`;
  }
  return `https://cdn.qinsilk.com/dms/prod/36c6bff927ce59e288e4750b4c86afa9.json?t=${new Date().getTime()}`;
}

let dmsConfig: any = null;
let dmsPromise: any = null;
export function initDms() {
  const url = getUrl();
  dmsPromise = new Promise((resolve, reject) => {
    fetch(url)
      .then((res: Recordable) => res.json())
      .then((data) => {
        dmsConfig = data;
        resolve(dmsConfig);
      });
  });
  return dmsPromise;
}

initDms();

export function getDmsConfig() {
  return new Promise((resolve, reject) => {
    if (dmsConfig) {
      resolve(dmsConfig);
    } else if (dmsPromise) {
      dmsPromise.then((config: any) => {
        resolve(config);
      });
    } else {
      initDms().then((config: any) => {
        resolve(config);
      });
    }
  });
}

export async function toGrayUrlForGrayUser(userId: string) {
  const config: any = await getDmsConfig();
  const { href } = window.location;
  const isGrayUser =
    config.grayUsers?.includes(String(userId)) ||
    config.grayUsers?.includes(`dev-${String(userId)}`) ||
    config.grayUsers?.includes(`prod-${String(userId)}`);
  if (isGrayUser && href.indexOf('gray-scm-front') === -1) {
    window.location.href = `${import.meta.env.VITE_scmServer}/gray-scm-front/`;
  } else if (!isGrayUser && href.indexOf('gray-scm-front') > -1) {
    window.location.href = `${import.meta.env.VITE_scmServer}/scm-front/`;
  }
}
